export const focusableElements = 'a[href], area[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled])'

export default function setTabIndex(parent, tabIndex) {
  Array.from(parent.querySelectorAll(focusableElements)).forEach(a => a.setAttribute('tabIndex', tabIndex))
}
